var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('q-icon',{staticClass:"fas fa-info-circle",attrs:{"size":"1.2rem"}}),_c('div',{staticClass:"q-pa-md"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }